var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSovDash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#F4F4F4",
    d: "m197.5,118.4c-7.5,-1.6 -14.4,-5 -23.2,-12.6l11.9,-13.6c6.6,5.7 10.4,7.9 15,8.7c1.4,0.3 2.7,0.5 4,0.5c2.1,0 4,-0.4 5.4,-1.1c1.2,-0.6 3.4,-2 3.4,-4.8c0,-2.9 -5.4,-4.7 -10.1,-5.6c-2.1,-0.4 -12.3,-2.6 -16.4,-5.1c-7.1,-4.2 -10.7,-10.5 -10.7,-18.4c0,-4.4 1.5,-8.5 3.9,-12.1c2.4,-3.3 5.7,-5.9 9.6,-7.7l-0.1,0.1c4,-1.9 8.4,-2.8 12.7,-2.8c1.8,0 3.4,0.1 5.5,0.4c6.7,1.1 12.8,3.9 21.3,10.9l-11.5,13.7c-7.7,-6.4 -11.7,-7.3 -15.6,-7.3c-2,0 -3.5,0.4 -4.8,1c-2,0.8 -3,2.3 -3,3.6c0,2.8 3.7,4.2 9.8,5.4c0.6,0.2 1.4,0.2 2.1,0.4c4.1,0.9 10.1,2.2 14.1,4.5l-0.1,0c7.5,4.2 11.5,10.7 11.5,18.8c0,4.8 -1.2,9.3 -4,13c-2.4,3.4 -5.9,5.9 -9.9,7.9c-4.2,2.2 -8.4,2.8 -13.1,2.8c-2.7,0.2 -5.4,-0.1 -7.7,-0.6z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#F4F4F4",
    d: "m327.8,81.1c0,21.1 -17.5,38.4 -38.6,38.4c-21.2,0 -38.5,-17.3 -38.5,-38.4c0,-21.3 17.3,-38.6 38.5,-38.6c21.1,0 38.6,17.3 38.6,38.6zm-18.2,0c0,-11.3 -9.1,-20.8 -20.4,-20.8c-11.3,0 -20.5,9.5 -20.5,20.8c0,11.2 9.2,20.5 20.5,20.5c11.3,0 20.4,-9.3 20.4,-20.5z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#F4F4F4",
    d: "m359.5,44.5l16.8,43.7l17,-43.7l19.3,0l-28.5,74.1l-15.3,0l-28.5,-74.1l19.2,0z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#DF691A",
    d: "m443.7,109.8c0,5.4 -4.3,9.6 -9.5,9.6s-9.6,-4.2 -9.6,-9.6c0,-5.2 4.4,-9.5 9.6,-9.5s9.5,4.3 9.5,9.5z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#F4F4F4",
    d: "m508.6,101.7l-20.8,0l-6.6,16.9l-19.2,0l28.5,-74.1l15.2,0l28.6,74.1l-19.3,0l-6.4,-16.9zm-10.4,-28.5l-3.5,10.8l7,0l-3.5,-10.8z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#F4F4F4",
    d: "m558.9,44.5l18.1,0l0,74.1l-18.1,0l0,-74.1z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#F4F4F4",
    d: "m85,20.6l-14.9,8.6l-37.1,21.4l0,15.3l0,0l0,28.3l0,16.9l0,0.2l52,30l14.9,-8.6l37.2,-21.4l0,-11.7l0,0l0,-31.9l0,-13.3l0,-3.8l-52.1,-30zm37.1,73.6l0,3.8l0,1.6l0,3.1l-6.8,3.9l-26.8,-15.5l0,0l-40.7,-23.5l0,-1.9l0,-2l0,-4.7l6.8,-3.9l26.8,15.5l0,0l40.7,23.6zm-74.3,-9.3l52,30.8l-10.2,5.9l0,0l-4.6,2.7l-37.1,-21.4l0,-18l-0.1,0zm74.3,-7.8l-52,-30.8l14.8,-8.6l37.1,21.4l0,18l0.1,0z",
    className: "st1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovDash);
export default __webpack_public_path__ + "static/media/sov_dash.38ad809e4a791e0296dbbd770187ed88.svg";
export { ForwardRef as ReactComponent };